import { useTranslation } from "react-i18next";

interface BrandLogoProps {
  variant?: "light" | "dark";
  className?: string;
}

export default function BrandLogo({ variant = "dark", className = "" }: BrandLogoProps) {
  const { t } = useTranslation();
  const isDark = variant === "dark";
  return (
    <a href="#home" className={`flex items-center gap-3 cursor-pointer ${className}`}>
      <div className="w-11 h-11 rounded-lg bg-primary-500 flex items-center justify-center shrink-0">
        <i className="ri-motorbike-fill text-background-50 text-2xl w-6 h-6 flex items-center justify-center" />
      </div>
      <div className="leading-tight">
        <div
          className={`font-heading font-extrabold text-lg tracking-tight ${
            isDark ? "text-foreground-900" : "text-background-50"
          }`}
        >
          {t("brand.name")}
        </div>
        <div className={`text-xs font-medium ${isDark ? "text-foreground-500" : "text-background-50/70"}`}>
          {t("brand.sub")}
        </div>
      </div>
    </a>
  );
}